import React from "react";
import {
  documentTextOutline,
  documentTextSharp,
  folderOutline,
  folderSharp,
  createOutline,
  createSharp,
  listOutline,
  listSharp,
  eyeOutline,
  eyeSharp,
  trendingDownOutline,
  trendingDownSharp,
  journalOutline,
  journalSharp,
  swapHorizontalOutline,
  swapHorizontalSharp,
} from "ionicons/icons";

// Import all components

import AssetRegisterList from "./AssetRegister/AssetRegisterList";
import AssetDetail from "./AssetRegister/AssetDetail";
import CreateAsset from "./AssetRegister/CreateAsset";
import EditAsset from "./AssetRegister/EditAsset";
import DepreciationView from "./AssetRegister/DepreciationView";

import GeneralLedgerView from "./GeneralLedger/GeneralLedgerView";
import ManualLedgerPosting from "./GeneralLedger/ManualLedgerPosting";
import PackagePosting from "./GeneralLedger/PackagePosting";
import ReversalEntries from "./GeneralLedger/ReversalEntries";
import MyReport from "./GeneralLedger/MyReport";
import AllReport from "./GeneralLedger/AllReport";
import PostingsByPostCode from "./GeneralLedger/PostingsByPostCode";

export interface PageConfig {
  path: string;
  component: React.ComponentType;
  icon: string;
  iosIcon?: string;
  mdIcon?: string;
  title: string;
  parentPath?: string; // Path of parent page (for hierarchy)
  level: number; // Hierarchy level (0 = top level, 1 = child, etc.)
  sortOrder: number; // Order within the same level
}

export const coreAccountingPages: PageConfig[] = [
  // Asset Register Pages
  {
    path: "/chart-asset-register/asset-register",
    component: AssetRegisterList,
    icon: folderOutline,
    iosIcon: folderOutline,
    mdIcon: folderSharp,
    title: "Asset Register",
    level: 0,
    sortOrder: 2,
  },
  {
    path: "/core-accounting/asset-register/:id/edit",
    component: EditAsset,
    icon: createOutline,
    iosIcon: createOutline,
    mdIcon: createSharp,
    title: "Edit Asset",
    parentPath: "/core-accounting/asset-register",
    level: 1,
    sortOrder: 2,
  },
  {
    path: "/core-accounting/asset-register/:id",
    component: AssetDetail,
    icon: eyeOutline,
    iosIcon: eyeOutline,
    mdIcon: eyeSharp,
    title: "Asset Detail",
    parentPath: "/core-accounting/asset-register",
    level: 1,
    sortOrder: 3,
  },
  {
    path: "/core-accounting/asset-register/create",
    component: CreateAsset,
    icon: createOutline,
    iosIcon: createOutline,
    mdIcon: createSharp,
    title: "Create Asset",
    parentPath: "/core-accounting/asset-register",
    level: 1,
    sortOrder: 1,
  },
  {
    path: "/core-accounting/asset-register/depreciation",
    component: DepreciationView,
    icon: trendingDownOutline,
    iosIcon: trendingDownOutline,
    mdIcon: trendingDownSharp,
    title: "Depreciation View",
    parentPath: "/core-accounting/asset-register",
    level: 1,
    sortOrder: 4,
  },

  // General Ledger Pages
  {
    path: "/core-accounting/general-ledger",
    component: GeneralLedgerView,
    icon: journalOutline,
    iosIcon: journalOutline,
    mdIcon: journalSharp,
    title: "General Ledger",
    level: 0,
    sortOrder: 3,
  },
  {
    path: "/core-accounting/general-ledger/my-report",
    component: MyReport,
    icon: documentTextOutline,
    iosIcon: documentTextOutline,
    mdIcon: documentTextSharp,
    title: "My Report",
    parentPath: "/core-accounting/general-ledger",
    level: 1,
    sortOrder: 1,
  },
  {
    path: "/core-accounting/general-ledger/all-report",
    component: AllReport,
    icon: documentTextOutline,
    iosIcon: documentTextOutline,
    mdIcon: documentTextSharp,
    title: "All Report",
    parentPath: "/core-accounting/general-ledger",
    level: 1,
    sortOrder: 2,
  },
  {
    path: "/core-accounting/general-ledger/manual-entry",
    component: ManualLedgerPosting,
    icon: createOutline,
    iosIcon: createOutline,
    mdIcon: createSharp,
    title: "Ledger Posting (Manual)",
    parentPath: "/core-accounting/general-ledger",
    level: 1,
    sortOrder: 3,
  },
  {
    path: "/core-accounting/general-ledger/package-posting",
    component: PackagePosting,
    icon: listOutline,
    iosIcon: listOutline,
    mdIcon: listSharp,
    title: "Package Posting",
    parentPath: "/core-accounting/general-ledger",
    level: 1,
    sortOrder: 4,
  },
  {
    path: "/folder/core-accounting/general-ledger/postings-by-post-code",
    parentPath: "/core-accounting/general-ledger",
    component: PostingsByPostCode,
    icon: listOutline,
    iosIcon: listOutline,
    mdIcon: listSharp,
    title: "Postings by Post Code",
    level: 1,
    sortOrder: 5,
  },
  {
    path: "/folder/core-accounting/general-ledger/reverse/:id",
    component: ReversalEntries,
    icon: swapHorizontalOutline,
    iosIcon: swapHorizontalOutline,
    mdIcon: swapHorizontalSharp,
    title: "Reversal Entries",
    parentPath: "/core-accounting/general-ledger",
    level: 1,
    sortOrder: 6,
  },
];
